<template>
	<div class="m-header-shell" :class="{ 'm-header-shell--en': currentLocale === 'en' }">
		<!-- 头部下载app -->
		<MNavDown v-if="isShowMNavdown" v-model="isShowMNavdown" />
		<van-sticky
			:offset-top="props.stickyOffset"
			:container="stickyContainer"
			:class="{ 'm-header-sticky--above-popup': showUserCenterDrawer || showSideDrawer }"
		>
			<div ref="headerBarRef" class="m-header">
				<div class="m-header-top" :class="{ 'm-header-top--drawer-open': isAnyDrawerOpen }">
					<img class="icon-logo" :src="headerLogoSrc" alt="" role="presentation" @click="goHome" />

					<div class="m-header-top-right">
						<button
							v-if="!isAnyDrawerOpen && !isSearchRoute(normalizedRoutePath)"
							type="button"
							class="header-search"
							aria-label="搜尋"
							@click="handleHeaderSearch"
						>
							<img class="header-search__icon" :src="iconSearch" alt="" aria-hidden="true" />
						</button>
						<button
							type="button"
							class="icon-menu-btn"
							:aria-label="isAnyDrawerOpen ? '關閉選單' : '開啟選單'"
							@click="toggleHeaderDrawer"
						>
							<img
								v-if="isAnyDrawerOpen"
								class="icon-close"
								:src="iconClose"
								alt=""
								aria-hidden="true"
							/>
							<img
								v-else
								class="icon-menu"
								src="@/assets/images/menu.png"
								alt=""
								aria-hidden="true"
							/>
						</button>
					</div>
				</div>
				<nav v-if="showPrimaryNav" class="m-header-nav" aria-label="主選單">
					<button
						v-for="(item, index) in menuList"
						:key="item.path"
						type="button"
						class="m-header-nav__item"
						:class="{ 'm-header-nav__item--active': isPrimaryNavActive(item) }"
						@click="handlePrimaryNavClick(item, index)"
					>
						{{ item.name }}
					</button>
				</nav>
			</div>
		</van-sticky>
		<van-popup
			v-model:show="showSideDrawer"
			position="left"
			:class="['m-side-drawer-popup', { 'm-side-drawer-popup--en': currentLocale === 'en' }]"
			overlay-class="m-side-drawer-overlay"
			:style="drawerPopupStyle"
			:overlay-style="drawerOverlayStyle"
			:z-index="2300"
		>
			<div class="side-drawer">
				<header class="side-drawer-header">
					<img
						class="side-drawer-logo"
						:src="drawerLogo"
						alt=""
						role="presentation"
						@click="goHome"
					/>
					<button
						type="button"
						class="side-drawer-close"
						aria-label="關閉選單"
						@click="closeHeaderDrawers"
					>
						<img :src="iconClose" alt="" aria-hidden="true" />
					</button>
				</header>
				<nav class="side-drawer-nav" :aria-label="t('mHeader.drawer.languageRow')">
					<div
						v-for="item in drawerNavItems"
						:key="item.key"
						class="side-drawer-nav-item"
						:class="{
							'side-drawer-nav-item--active': isDrawerItemActive(item),
						}"
						@click="handleDrawerItemClick(item)"
					>
						<div
							v-if="isDrawerItemActive(item)"
							class="side-drawer-nav-item__bg"
							aria-hidden="true"
						/>
						<div
							v-if="isDrawerItemActive(item)"
							class="side-drawer-nav-item__indicator"
							aria-hidden="true"
						/>
						<div class="side-drawer-nav-item__inner">
							<span class="side-drawer-nav-item__text">{{ item.label }}</span>
							<div
								v-if="item.type === 'language'"
								class="side-drawer-lang"
								role="group"
								:aria-label="t('mHeader.drawer.languageRow')"
								@click.stop
							>
								<button
									type="button"
									class="side-drawer-lang-btn"
									:class="{ 'side-drawer-lang-btn--active': currentLocale === 'zh-TW' }"
									:aria-pressed="currentLocale === 'zh-TW'"
									:aria-label="
										currentLocale === 'zh-TW'
											? t('mHeader.drawer.targetZh')
											: t('mHeader.drawer.ariaSwitchToZh')
									"
									@click="setDrawerLocale('zh-TW')"
								>
									{{ t("mHeader.drawer.targetZh") }}
								</button>
								<button
									type="button"
									class="side-drawer-lang-btn"
									:class="{ 'side-drawer-lang-btn--active': currentLocale === 'en' }"
									:aria-pressed="currentLocale === 'en'"
									:aria-label="
										currentLocale === 'en'
											? t('mHeader.drawer.targetEn')
											: t('mHeader.drawer.ariaSwitchToEn')
									"
									@click="setDrawerLocale('en')"
								>
									{{ t("mHeader.drawer.targetEn") }}
								</button>
							</div>
							<img
								v-else
								class="side-drawer-chevron"
								src="./images/icon_chevron.svg"
								alt=""
								aria-hidden="true"
							/>
						</div>
					</div>
				</nav>

				<div class="side-drawer-footer">
					<div class="side-drawer-shortcuts">
						<div class="side-drawer-shortcuts-row">
							<button
								v-for="item in drawerShortcuts"
								:key="item.key"
								type="button"
								class="side-drawer-shortcut"
								@click="handleDrawerShortcutClick(item)"
							>
								<img
									class="side-drawer-shortcut__icon"
									:src="item.icon"
									alt=""
									aria-hidden="true"
								/>
								<span>{{ item.label }}</span>
							</button>
						</div>
						<p class="side-drawer-version">v4.1.0</p>
					</div>
				</div>
			</div>
		</van-popup>

		<UserCenterDrawer v-model:show="showUserCenterDrawer" @back="handleUserCenterDrawerBack" />

		<van-popup
			v-model:show="showInterestPopup"
			round
			closeable
			close-icon="cross"
			:class="['interest-popup', { 'interest-popup--en': currentLocale === 'en' }]"
			:style="{ width: '88%', maxHeight: '75%' }"
		>
			<div class="interest-popup-body">
				<div class="interest-popup-title">{{ interestTitle }}</div>
				<div class="interest-popup-subtitle">{{ interestSubtitle }}</div>

				<div v-if="loading" class="interest-status">{{ interestLoading }}</div>
				<div v-else class="interest-options">
					<button
						v-for="item in displayOptions"
						:key="item"
						class="interest-option"
						:class="{ active: selectedTags.includes(item) }"
						@click="toggleTag(item)"
					>
						{{ item }}
					</button>
				</div>

				<button
					class="interest-submit-btn"
					:class="{ disabled: !selectedTags.length || submitting }"
					:disabled="!selectedTags.length || submitting"
					@click="handleConfirm"
				>
					{{ interestSubmitLabel }}
				</button>
			</div>
		</van-popup>
	</div>
</template>

<script setup>
import { useUserStore } from "~/stores/user";
import { downloadApp, parseUA } from "~/utils/common";
import {
	getColdStartCandidateTags,
	getColdStartUserSelectedTags,
	getUserInfo,
	trackEvents,
} from "~/api/api";
import { buildColdStartTagsTrackPayload, clearColdStartTagsPending } from "~/utils/coldStartTags";
import eventBus, { EVENT_TYPES } from "~/utils/eventBus";

import { storeToRefs } from "pinia";
import { computed, inject, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useMsgCountStore } from "~/stores/msg-count";
import { useI18n } from "~/composables/useI18n";
import { isStandaloneSectionPath } from "~/utils/corporate-center-route";
import {
	mapTrackingLanguage,
	useSiteComponentTracking,
} from "~/composables/useSiteComponentTracking";
import { useUserCenterTracking } from "@variants/seer/user/composables/useUserCenterTracking";
import { stripLocalePrefix } from "~/utils/i18n-locale-routes";

import headerLogoZh from "@/assets/images/SeerQtw.svg";
import headerLogoEn from "@/assets/images/SeerQ.svg";
import iconKefu from "./images/icon_kefu.svg";
import iconMentor from "./images/icon_mentor.svg";
import iconInstitution from "./images/icon_institution.svg";
import iconSearch from "./images/icon_search.svg";
import iconClose from "./images/icon_close.svg";
import drawerLogo from "./images/logo.png";

import MNavDown from "~/components/m/navdown/index.vue";
import UserCenterDrawer from "~/pages/seer/user/m/components/UserCenterDrawer/index.vue";

const { t, locale, setLocale } = useI18n();
const { track, trackHomepageView } = useSiteComponentTracking("mobile");
const userCenterTracking = useUserCenterTracking("mobile");

const drawerUserCenter = computed(() => t("mHeader.drawer.userCenter"));
const drawerDownloadApp = computed(() => t("mHeader.drawer.downloadApp"));
const drawerLanguageSwitch = computed(() => t("mHeader.drawer.languageSwitch"));
const currentLocale = computed(() => locale?.value || "zh-TW");

const headerLogoSrc = computed(() => (locale?.value === "en" ? headerLogoEn : headerLogoZh));

const interestTitle = computed(() => t("mHeader.interest.title"));
const interestSubtitle = computed(() => t("mHeader.interest.subtitle"));
const interestLoading = computed(() => t("mHeader.interest.loading"));
const interestSubmitLabel = computed(() =>
	t("mHeader.interest.submit", { count: selectedTags.value.length })
);

// 定义props
const props = defineProps({
	stickyOffset: {
		type: Number,
		default: 0,
	},
});

const router = useRouter(); // Nuxt's useRouter
const route = useRoute(); // Nuxt's useRoute

const setDrawerLocale = next => {
	if (currentLocale.value === next) return;
	track("language_switch_click", {
		from_language: mapTrackingLanguage(currentLocale.value),
		to_language: mapTrackingLanguage(next),
	});
	setLocale(next);
};

const isShowMNavdown = ref(false); //是否有顶部菜单栏
const stickyContainer = ref(null); // 吸顶容器
const headerBarRef = ref(null);
const drawerTopPx = ref(0);
const showSideDrawer = ref(false);
const showUserCenterDrawer = ref(false);
const SIDE_DRAWER_CLOSE_MS = 320;

const useUser = useUserStore();
const { userInfo, isLogin } = storeToRefs(useUser);
const menuSelected = ref("");
const isAnyDrawerOpen = computed(() => showSideDrawer.value || showUserCenterDrawer.value);

const syncDrawerTop = () => {
	if (!import.meta.client) return;
	const el = headerBarRef.value;
	if (!el) return;
	const bottom = Math.round(el.getBoundingClientRect().bottom);
	drawerTopPx.value = bottom > 0 ? bottom : drawerTopPx.value;
};

const drawerPopupStyle = computed(() => {
	return {
		width: currentLocale.value === "en" ? "82%" : "72%",
		top: "0",
		height: "100%",
	};
});

const drawerOverlayStyle = computed(() => {
	return {
		background: "rgba(0, 0, 0, 0.7)",
		top: "0",
		height: "100%",
	};
});

const openSideDrawer = () => {
	syncDrawerTop();
	if (isLogin.value) {
		showUserCenterDrawer.value = true;
		nextTick(syncDrawerTop);
		return;
	}
	showSideDrawer.value = true;
	nextTick(syncDrawerTop);
};

const closeHeaderDrawers = () => {
	showSideDrawer.value = false;
	showUserCenterDrawer.value = false;
};

const toggleHeaderDrawer = () => {
	if (isAnyDrawerOpen.value) {
		closeHeaderDrawers();
		return;
	}
	openSideDrawer();
};

const openUserCenterDrawer = async () => {
	track("account_entry_click", {
		element_id: "account_icon",
	});
	userCenterTracking.trackNavClick("default", {
		nav_item: "profile_archive",
	});
	await closeSideDrawerAsync();
	await nextTick();
	syncDrawerTop();
	showUserCenterDrawer.value = true;
	await nextTick(syncDrawerTop);
};

const handleUserCenterDrawerBack = async () => {
	if (!showUserCenterDrawer.value) return;
	showUserCenterDrawer.value = false;
	await new Promise(resolve => setTimeout(resolve, SIDE_DRAWER_CLOSE_MS));
	syncDrawerTop();
	showSideDrawer.value = true;
};

/** 关闭侧栏并等待 van-popup 动画结束，避免 teleport 节点在路由切换时 insertBefore 报错 */
const closeSideDrawerAsync = () =>
	new Promise(resolve => {
		if (!showSideDrawer.value) {
			resolve();
			return;
		}
		showSideDrawer.value = false;
		setTimeout(resolve, SIDE_DRAWER_CLOSE_MS);
	});

/** 从无 Layout 壳（mentor-join / corporate-center）跳出时整页跳转，避免 app.vue 切换 Layout 导致白屏 */
const shouldHardNavigate = targetPath => {
	const path = String(targetPath || "").split("?")[0];
	return isStandaloneSectionPath(route.path) && !isStandaloneSectionPath(path);
};

const navigateFromHeader = async to => {
	const path = typeof to === "string" ? to : to?.path;
	await closeSideDrawerAsync();
	await nextTick();
	if (path && shouldHardNavigate(path)) {
		window.location.assign(typeof to === "string" ? to : path);
		return;
	}
	await navigateTo(to);
};

const showInterestPopup = ref(false);
const loading = ref(false);
const submitting = ref(false);
const remoteOptions = ref([]);
const selectedTags = ref([]);
const isInterestSubmitSuccess = ref(false);
const SQUARE_MEDIA_REFRESH_EVENT = "square-media-refresh";
const COLD_START_TAGS_TAB_SWITCH_EVENT = "cold-start-tags-tab-switch";

const FALLBACK_INTEREST_OPTIONS = [
	"塔羅",
	"星座",
	"八字",
	"紫微斗數",
	"手相",
	"相學",
	"奇門遁甲",
	"生肖",
	"風水",
	"神秘事件",
	"心理",
	"冥想",
	"心靈療愈",
	"靈性成長",
	"事業",
	"家庭",
	"健康",
	"婚姻",
	"感情",
	"財運",
	"祈福",
	"驅邪",
];

const normalizeOptions = list => {
	if (!Array.isArray(list)) return [];
	return [...new Set(list.map(item => String(item || "").trim()).filter(Boolean))];
};

const displayOptions = computed(() => {
	if (remoteOptions.value.length) {
		return remoteOptions.value;
	}
	return FALLBACK_INTEREST_OPTIONS;
});

const hasShownColdStartTags = () => {
	if (!import.meta.client || typeof window === "undefined") return false;
	return localStorage.getItem("cold_start_tags_shown") === "1";
};

const markColdStartTagsShown = () => {
	if (!import.meta.client || typeof window === "undefined") return;
	localStorage.setItem("cold_start_tags_shown", "1");
};

const shouldShowDialogByUserSelectedTags = async () => {
	const userId = await resolveUserId();
	if (!userId) return false;

	try {
		const res = await getColdStartUserSelectedTags(userId);
		const userSelectedTags = res?.data?.user_selected_tags;
		return Array.isArray(userSelectedTags) && userSelectedTags.length === 0;
	} catch (error) {
		console.error("检查媒体广场弹窗状态失败:", error);
		return false;
	}
};

const handleAutoTriggerInterestPopup = async () => {
	if (!isLogin.value || showInterestPopup.value) return;
	if (hasShownColdStartTags()) return;
	if (!(await shouldShowDialogByUserSelectedTags())) return;

	markColdStartTagsShown();
	isInterestSubmitSuccess.value = false;
	showInterestPopup.value = true;
};

// 客户端初始化
onMounted(() => {
	if (
		stripLocalePrefix(route.path) === "/" &&
		typeof localStorage !== "undefined" &&
		localStorage.getItem("isShowMNavdown") !== "hide"
	) {
		isShowMNavdown.value = true;
	}
});

watch(route, val => {
	if (import.meta.client) {
		if (
			stripLocalePrefix(val.path) === "/" &&
			typeof localStorage !== "undefined" &&
			localStorage.getItem("isShowMNavdown") !== "hide"
		) {
			isShowMNavdown.value = true;
		} else {
			isShowMNavdown.value = false;
		}
	}
});

watch(showSideDrawer, visible => {
	if (visible) {
		nextTick(syncDrawerTop);
	}
});

// 菜单栏（文案 i18n）
const MENU_DEFS = [
	{ path: "/", nameKey: "home", elementId: "nav_home" },
	{ path: "/seer/square", nameKey: "square", elementId: "nav_square" },
	{
		path: "/seer/service-institution",
		nameKey: "serviceInstitution",
		elementId: "nav_service_institution",
	},
	{ path: "/seer/aboutus", nameKey: "about", elementId: "nav_about_us" },
];

const menuList = computed(() => {
	const base = MENU_DEFS.map(def => ({
		path: def.path,
		name: t(`mHeader.nav.${def.nameKey}`),
		elementId: def.elementId,
	}));

	try {
		let hostname = "";
		if (import.meta.server) {
			const headers = useRequestHeaders(["host", "x-forwarded-host"]);
			hostname = headers["x-forwarded-host"] || headers["host"] || "";
		} else {
			const url = useRequestURL();
			hostname = url.hostname;
		}

		if (hostname.includes("seerify.shop")) {
			return base.filter(item => !["/seer/onlinecs", "/seer/master-fortune"].includes(item.path));
		}
	} catch (e) {
		console.log(e);
	}
	return base;
});

const drawerNavItems = computed(() => {
	const actionItems = [
		{
			key: "user-center",
			type: "userCenter",
			label: drawerUserCenter.value,
		},
		{
			key: "order-query",
			type: "order",
			label: t("user.pc.order.title"),
		},
	];

	if (!isShowMNavdown.value || !isLogin.value) {
		actionItems.push({
			key: "download-app",
			type: "download",
			label: drawerDownloadApp.value,
		});
	}

	actionItems.push({
		key: "language",
		type: "language",
		label: drawerLanguageSwitch.value,
	});

	if (!isLogin.value) {
		actionItems.push({
			key: "login-register",
			type: "login",
			label: t("mHeader.drawer.loginRegister"),
		});
	}

	return actionItems;
});

const findActiveMenuIndex = normalizedPath => {
	return menuList.value.findIndex(menu => {
		if (menu.path === normalizedPath) return true;

		if (menu.path === "/seer/square") {
			return normalizedPath === "/seer/square" || normalizedPath.startsWith("/seer/square/");
		}

		return false;
	});
};

const normalizedRoutePath = computed(() => stripLocalePrefix(route.path));

const isSearchRoute = path => path === "/seer/search" || path.startsWith("/seer/search/");
const isSquareArticleRoute = path =>
	path === "/seer/square/article" || path.startsWith("/seer/square/article/");

const showPrimaryNav = computed(() => {
	if (isAnyDrawerOpen.value) return false;
	if (isSquareArticleRoute(normalizedRoutePath.value)) return false;
	return MENU_DEFS.some(item => isRouteMatched(item.path, normalizedRoutePath.value));
});

const isPrimaryNavActive = item => {
	const activeIndex = findActiveMenuIndex(normalizedRoutePath.value);
	const itemIndex = menuList.value.findIndex(menu => menu.path === item.path);
	return activeIndex !== -1 && activeIndex === itemIndex;
};

const drawerShortcuts = computed(() => [
	{
		key: "contact-cs",
		label: t("mHeader.drawer.contactCs"),
		path: "/seer/onlinecs",
		icon: iconKefu,
	},
	{
		key: "mentor-join",
		label: t("mHeader.drawer.mentorJoin"),
		path: "/seer/mentor-join",
		icon: iconMentor,
	},
	{
		key: "institution-join",
		label: t("mHeader.drawer.institutionJoin"),
		path: "/seer/corporate-center",
		icon: iconInstitution,
	},
]);

const isRouteMatched = (path, currentPath) => {
	if (path === "/") return currentPath === "/";
	return currentPath === path || currentPath.startsWith(`${path}/`);
};

const isDrawerItemActive = item => {
	const currentPath = normalizedRoutePath.value;
	if (item.type === "userCenter") {
		return currentPath === "/seer/user" || currentPath.startsWith("/seer/user/");
	}
	if (item.type !== "nav") return false;
	return isRouteMatched(item.path, currentPath);
};

const handleDrawerItemClick = async item => {
	if (item.type === "language") return;

	if (item.type === "login") {
		await loginHandler();
		return;
	}

	if (item.type === "userCenter") {
		if (isLogin.value) {
			await openUserCenterDrawer();
		} else {
			await loginHandler();
		}
		return;
	}

	if (item.type === "download") {
		await toAppStore();
		return;
	}

	if (item.type === "order") {
		userCenterTracking.trackNavClick("order", {
			nav_item: "orders",
		});
		if (!isLogin.value) {
			await closeSideDrawerAsync();
			openLoginPopup?.(
				() => {
					showSideDrawer.value = false;
					navigateTo({ path: "/seer/user", query: { type: "order" } });
				},
				null,
				false,
				"header_account"
			);
			return;
		}
		await navigateFromHeader({ path: "/seer/user", query: { type: "order" } });
		return;
	}

	if (item.type === "nav" && item.path) {
		await navigateFromHeader({ path: item.path });
		if (item.path === "/seer/square" && isLogin.value) {
			eventBus.emit(COLD_START_TAGS_TAB_SWITCH_EVENT);
		}
	}
};

const handleDrawerShortcutClick = async item => {
	if (item.key === "contact-cs") {
		userCenterTracking.trackCustomerSupportClick({
			trigger_position: "mobile_header_drawer_shortcut",
		});
	}
	await navigateFromHeader({ path: item.path });
};

const handlePrimaryNavClick = async (item, index) => {
	if (!item?.path) return;
	track("nav_item_click", {
		element_id: item.elementId,
		element_text: item.name,
		position: index + 1,
		target_url: item.path,
	});
	await navigateFromHeader({ path: item.path });
	if (item.path === "/seer/square" && isLogin.value) {
		eventBus.emit(COLD_START_TAGS_TAB_SWITCH_EVENT);
	}
};

const handleHeaderSearch = async () => {
	track("search_entry_click", {
		element_id: "top_search",
	});
	await navigateFromHeader({ path: "/seer/search", query: { trigger_position: "top_search" } });
};
// 监听路由变化
watch(route, newRoute => {
	const normalizedPath = stripLocalePrefix(newRoute.path);
	const matchingIndex = findActiveMenuIndex(normalizedPath);
	if (matchingIndex !== -1) {
		menuSelected.value = matchingIndex;
	} else {
		menuSelected.value = "";
	}
});

// 初始化设置选中的菜单项
const initMenuSelect = () => {
	const normalizedPath = stripLocalePrefix(route.path);
	const matchingIndex = findActiveMenuIndex(normalizedPath);
	if (matchingIndex !== -1) {
		menuSelected.value = matchingIndex;
	}
};

// 初始化吸顶容器
const initStickyContainer = () => {
	const mobileLayout = document.querySelector(".mobile-layout");
	if (mobileLayout) {
		stickyContainer.value = mobileLayout;
	}
};

// 是否有未读消息
const { unReadMsgTotalCount } = storeToRefs(useMsgCountStore()); //未读消息数
const goMessagePage = async () => {
	await navigateFromHeader("/seer/user?type=message");
};

// 登录按钮
const openLoginPopup = inject("openLoginPopup");

// 用户信息
async function loginHandler() {
	track("account_entry_click", {
		element_id: "account_icon",
	});
	userCenterTracking.trackNavClick("default", {
		nav_item: "profile_archive",
	});
	await closeSideDrawerAsync();
	openLoginPopup?.(
		() => {
			showSideDrawer.value = false;
		},
		null,
		false,
		"header_account"
	);
}

const resetSelection = () => {
	selectedTags.value = [];
};

const toggleTag = tag => {
	const nextSelected = [...selectedTags.value];
	const activeIndex = nextSelected.indexOf(tag);

	if (activeIndex > -1) {
		nextSelected.splice(activeIndex, 1);
		selectedTags.value = nextSelected;
		return;
	}

	nextSelected.push(tag);
	selectedTags.value = nextSelected;
};

const fetchOptions = async () => {
	loading.value = true;
	try {
		const res = await getColdStartCandidateTags();
		const remoteTags = normalizeOptions(res?.data?.cold_start_candidate_tags);
		remoteOptions.value = remoteTags;
	} catch (error) {
		console.error("獲取冷啟動候選標籤失敗:", error);
	} finally {
		loading.value = false;
	}
};

const resolveUserId = async () => {
	try {
		const res = await getUserInfo();
		return res?.data?.user_id || res?.data?.uid || res?.data?.id || res?.data?.socket_uid || "";
	} catch (error) {
		console.error("獲取當前用戶 ID 失敗:", error);
		return "";
	}
};

const handleConfirm = async () => {
	if (!selectedTags.value.length) return;

	submitting.value = true;
	try {
		const userId = await resolveUserId();
		const payload = buildColdStartTagsTrackPayload(selectedTags.value, userId);
		await trackEvents(payload);
		clearColdStartTagsPending();
		isInterestSubmitSuccess.value = true;
		showInterestPopup.value = false;
		eventBus.emit(SQUARE_MEDIA_REFRESH_EVENT);
	} catch (error) {
		console.error("提交冷啟動標籤失敗:", error);
	} finally {
		submitting.value = false;
	}
};

// 跳转个人中心
async function goUserCenter() {
	track("account_entry_click", {
		element_id: "account_icon",
	});
	userCenterTracking.trackNavClick("default", {
		nav_item: "profile_archive",
	});
	await navigateFromHeader("/seer/user");
}

// 跳转首页
async function goHome() {
	track("nav_logo_click", {
		element_id: "logo",
		target_url: "/",
	});
	await navigateFromHeader("/");
}

// 下載app
const toAppStore = async () => {
	const res = parseUA();
	track("app_download_click", {
		element_id: "download_app_top",
		store_type: res.android ? "google_play" : res.ios ? "app_store" : "unknown",
	});
	await closeSideDrawerAsync();
	downloadApp();
};

watch(
	() => showUserCenterDrawer.value,
	visible => {
		if (visible) nextTick(syncDrawerTop);
	}
);

watch(
	() => showInterestPopup.value,
	async visible => {
		if (!visible) {
			return;
		}
		resetSelection();
		isInterestSubmitSuccess.value = false;
		await fetchOptions();
	}
);

onMounted(() => {
	initStickyContainer();
	syncDrawerTop();
	trackHomepageView();
	if (import.meta.client) {
		window.addEventListener("resize", syncDrawerTop);
	}
	eventBus.on(COLD_START_TAGS_TAB_SWITCH_EVENT, handleAutoTriggerInterestPopup);
	eventBus.on(EVENT_TYPES.OPEN_USER_CENTER_DRAWER, openUserCenterDrawer);
});

onBeforeUnmount(() => {
	if (import.meta.client) {
		window.removeEventListener("resize", syncDrawerTop);
	}
	eventBus.off(COLD_START_TAGS_TAB_SWITCH_EVENT, handleAutoTriggerInterestPopup);
	eventBus.off(EVENT_TYPES.OPEN_USER_CENTER_DRAWER, openUserCenterDrawer);
});
</script>

<style lang="scss" scoped>
.m-header-shell--en {
	.m-header {
		&-top {
			padding: 0 24px;

			.icon-logo {
				width: 176px;
			}

			&-right {
				gap: 16px;
				min-width: 0;
			}
		}

		.header-search {
			width: 56px;
			height: 56px;
		}

		.header-search__icon {
			width: 28px;
			height: 28px;
		}

		&-nav {
			height: auto;
			min-height: 64px;
		}

		&-nav__item {
			padding: 8px 4px;
			font-size: 20px;
			line-height: 1.15;
			white-space: normal;
			overflow-wrap: anywhere;
			word-break: normal;
		}
	}
}

.m-header {
	position: relative;
	z-index: 2100;
	background-color: #ffffff;

	&-top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 112px;
		padding: 0 25px;
		border-bottom: 1px solid #dfdfdf;

		.icon-logo {
			width: 200px;
			height: auto;
		}

		&-right {
			display: flex;
			align-items: center;
			gap: 24px;
		}

		.icon-menu {
			width: 44px;
			height: 44px;
		}

		&--drawer-open {
			border-bottom-color: transparent;
		}
	}

	.header-search {
		display: inline-flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		width: 56px;
		height: 56px;
		padding: 0;
		border: none;
		border-radius: 50%;
		background: #111111;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		&__icon {
			display: block;
			width: 28px;
			height: 28px;
		}
	}

	.icon-menu-btn {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}

	.icon-close {
		width: 44px;
		height: 44px;
	}

	&-nav {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		height: 64px;
		background: #ffffff;
	}

	&-nav__item {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 0;
		height: 100%;
		padding: 0 2px;
		border: none;
		background: transparent;
		font-size: 24px;
		font-weight: 700;
		line-height: 1;
		color: #333333;
		white-space: nowrap;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		&--active {
			color: #f2af19;
		}
	}
}

.side-drawer {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #fff;

	&-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 176px;
		padding: 54px 32px 20px;
		flex-shrink: 0;
	}

	&-logo {
		width: 200px;
		height: auto;
		cursor: pointer;
	}

	&-close {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		img {
			width: 44px;
			height: 44px;
		}
	}

	&-nav {
		flex: 1;
		min-height: 0;
		padding: 18px 0 32px;
		display: flex;
		flex-direction: column;
		gap: 64px;
		overflow-y: auto;
	}

	&-nav-item {
		position: relative;
		flex-shrink: 0;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		&__inner {
			position: relative;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 48px;
			min-height: 32px;
		}

		&__text {
			font-size: 28px;
			font-weight: 400;
			line-height: 28px;
			color: #333333;
		}

		&__indicator {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 8px;
			height: 84px;
			background: #f2af19;
			border-radius: 62px;
			z-index: 1;
		}

		&__bg {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 94.8%;
			height: 84px;
			background: linear-gradient(90deg, #fff6e4 0%, #ffffff 100%);
			z-index: 0;
		}

		&--active {
			.side-drawer-nav-item__inner {
				min-height: 84px;
			}

			.side-drawer-nav-item__text {
				font-weight: 700;
			}
		}
	}

	&-chevron {
		width: 32px;
		height: 32px;
		flex-shrink: 0;
		transform: rotate(180deg);
	}

	&-lang {
		display: flex;
		width: 100px;
		height: 48px;
		border-radius: 8px;
		background: #e2e2e2;
		overflow: hidden;
		flex-shrink: 0;
	}

	&-lang-btn {
		flex: 1;
		border: none;
		background: transparent;
		padding: 0;
		font-size: 24px;
		font-weight: 500;
		line-height: 28px;
		color: #ffffff;
		white-space: nowrap;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		&--active {
			background: #333333;
		}
	}

	&-footer {
		flex-shrink: 0;
		padding: 0 32px 32px;
	}

	&-shortcuts {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 192px;
		border: 1px solid #efefef;
		border-radius: 20px;
		background: #ffffff;
	}

	&-shortcuts-row {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 62px;
		width: 100%;
		padding-top: 32px;
	}

	&-shortcut {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 8px;
		border: none;
		background: transparent;
		padding: 0;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		&__icon {
			width: 32px;
			height: 32px;
		}

		span {
			font-size: 24px;
			font-weight: 400;
			line-height: 40px;
			color: #333333;
			white-space: nowrap;
		}
	}

	&-version {
		margin: 10px 0 0;
		text-align: center;
		font-size: 20px;
		font-weight: 400;
		line-height: normal;
		color: #999999;
	}
}

.interest-popup {
	border-radius: 10px;
	overflow: hidden;
	display: flex;
	flex-direction: column;

	.interest-popup-body {
		display: flex;
		flex-direction: column;
		min-height: 0;
		max-height: 75vh;
		padding: 40px 30px 40px;
		background: #ffffff;
		box-sizing: border-box;

		.interest-popup-title {
			flex-shrink: 0;
			font-size: 32px;
			font-weight: bold;
			color: #333333;
		}

		.interest-popup-subtitle {
			flex-shrink: 0;
			margin: 20px 0 30px;
			font-size: 28px;
			color: #6f6f6f;
		}

		.interest-status {
			flex-shrink: 0;
			padding: 40px 0 20px;
			text-align: center;
			font-size: 28px;
			color: #888888;
		}

		.interest-options {
			flex: 1;
			min-height: 0;
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			gap: 14px;
			align-content: start;

			.interest-option {
				padding: 10px 0;
				border: 1px solid #f6f6f6;
				border-radius: 10px;
				background: #f6f6f6;
				color: #333333;
				font-size: 28px;
			}

			.interest-option.active {
				border-color: #c67f34;
				background: #fef8e8;
				color: #c67f34;
			}
		}

		.interest-submit-btn {
			flex-shrink: 0;
			margin-top: 40px;
			width: 100%;
			height: 100px;
			border: none;
			border-radius: 10px;
			background: #111111;
			color: #ffffff;
			font-size: 28px;
		}

		.interest-submit-btn.disabled {
			background: #cfcfcf;
			cursor: not-allowed;
		}
	}
}
</style>

<style lang="scss">
.m-side-drawer-popup.van-popup--left {
	transform: none;
}

.m-side-drawer-overlay {
	position: fixed;
}

.m-header-sticky--above-popup {
	z-index: 2200 !important;
}

.m-side-drawer-popup--en {
	.side-drawer {
		&-nav {
			gap: 36px;
		}

		&-nav-item__inner {
			gap: 16px;
			padding: 0 32px;
		}

		&-nav-item__text {
			min-width: 0;
			font-size: 26px;
			line-height: 1.25;
			overflow-wrap: anywhere;
			word-break: normal;
		}

		&-lang {
			width: 116px;
		}

		&-lang-btn {
			font-size: 18px;
			line-height: 1;
		}

		&-shortcuts-row {
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			align-items: start;
			gap: 8px;
			padding: 28px 12px 0;
			box-sizing: border-box;
		}

		&-shortcuts {
			height: auto;
			min-height: 192px;
			padding-bottom: 12px;
			box-sizing: border-box;
		}

		&-shortcut {
			width: 100%;
			min-width: 0;

			span {
				display: block;
				width: 100%;
				min-width: 0;
				font-size: 16px;
				line-height: 1.2;
				text-align: center;
				white-space: normal;
				overflow-wrap: anywhere;
				word-break: normal;
			}
		}
	}
}

.interest-popup.van-popup {
	max-height: 75%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.interest-popup.van-popup--center {
	top: 54%;
}

.interest-popup.van-popup .interest-popup-body {
	display: flex;
	flex-direction: column;
	min-height: 0;
	max-height: 75vh;
	overflow: hidden;
	box-sizing: border-box;
}

.interest-popup.van-popup .interest-options {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	align-content: start;
}

.interest-popup.van-popup .interest-submit-btn {
	flex-shrink: 0;
}

.interest-popup--en {
	.interest-popup-body {
		.interest-popup-title {
			font-size: 30px;
			line-height: 1.3;
			overflow-wrap: anywhere;
			word-break: normal;
		}

		.interest-popup-subtitle,
		.interest-status,
		.interest-submit-btn {
			font-size: 24px;
			line-height: 1.35;
		}

		.interest-options {
			grid-template-columns: repeat(2, minmax(0, 1fr));

			.interest-option {
				min-width: 0;
				font-size: 22px;
				line-height: 1.25;
				overflow-wrap: anywhere;
				word-break: normal;
			}
		}
	}
}
</style>
